import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideMSAL, TdoeToastComponent } from '@tdoe/design-system';
import { environment } from '../environments/environment';
import { provideToastr } from 'ngx-toastr';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { drupalInterceptor } from './interceptors/drupal-interceptor/drupal-interceptor';
import { provideAngularSvgIcon } from 'angular-svg-icon';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideMSAL(environment.msalConfig),
    provideToastr({ toastComponent: TdoeToastComponent }),
    provideHttpClient(withInterceptors([
      drupalInterceptor
    ])),
    provideAngularSvgIcon()
  ]
};
